'use strict'

const state = {
  isShown: false
}

const mutations = {
  show (state) {
    state.isShown = true
  },

  hide (state) {
    state.isShown = false
  }
}

const actions = {
  show ({commit}) {
    commit('show')
  },

  hide ({commit}) {
    commit('hide')
  }
}

const getters = {
  isShown (state) {
    return state.isShown
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
